export default __webpack_public_path__ + "assets/11238a10c406ee8642bbdea1a01a0648.ttf";